module.exports = __webpack_public_path__ + "img/livebtn.68fc77e1.png";